/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52107.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class TrackingControllerApi extends runtime.BaseAPI {
    /**
     * Create a tracking pixel. A tracking pixel is an image that can be embedded in an email. When the email is viewed and the image is seen MailSlurp will mark the pixel as seen. Use tracking pixels to monitor email open events. You can receive open notifications via webhook or by fetching the pixel.
     * Create tracking pixel
     */
    async createTrackingPixelRaw(requestParameters, initOverrides) {
        if (requestParameters.createTrackingPixelOptions === null || requestParameters.createTrackingPixelOptions === undefined) {
            throw new runtime.RequiredError('createTrackingPixelOptions', 'Required parameter requestParameters.createTrackingPixelOptions was null or undefined when calling createTrackingPixel.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/tracking/pixels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTrackingPixelOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a tracking pixel. A tracking pixel is an image that can be embedded in an email. When the email is viewed and the image is seen MailSlurp will mark the pixel as seen. Use tracking pixels to monitor email open events. You can receive open notifications via webhook or by fetching the pixel.
     * Create tracking pixel
     */
    async createTrackingPixel(requestParameters, initOverrides) {
        const response = await this.createTrackingPixelRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * List tracking pixels in paginated form
     * Get tracking pixels
     */
    async getAllTrackingPixelsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        if (requestParameters.searchFilter !== undefined) {
            queryParameters['searchFilter'] = requestParameters.searchFilter;
        }
        if (requestParameters.since !== undefined) {
            queryParameters['since'] = requestParameters.since;
        }
        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/tracking/pixels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * List tracking pixels in paginated form
     * Get tracking pixels
     */
    async getAllTrackingPixels(requestParameters = {}, initOverrides) {
        const response = await this.getAllTrackingPixelsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get pixel
     */
    async getTrackingPixelRaw(requestParameters, initOverrides) {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getTrackingPixel.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/tracking/pixels/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get pixel
     */
    async getTrackingPixel(requestParameters, initOverrides) {
        const response = await this.getTrackingPixelRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetAllTrackingPixelsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
